// A small dial in the HUD: the sun's arc by day, the moon's by night. Reads at a glance.
import { skyState } from '../render/sun';

export interface SkyDial {
  update(hour: number): void;
}

export function createSkyDial(parent: HTMLElement): SkyDial {
  const w = 64;
  const h = 30;
  const svgNs = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(svgNs, 'svg');
  svg.setAttribute('viewBox', `0 0 ${w} ${h}`);
  svg.setAttribute('width', String(w));
  svg.setAttribute('height', String(h));
  svg.classList.add('skydial');

  const track = document.createElementNS(svgNs, 'path');
  track.setAttribute('d', `M 4 ${h - 5} A 28 28 0 0 1 ${w - 4} ${h - 5}`);
  track.classList.add('skydial-track');
  const horizon = document.createElementNS(svgNs, 'line');
  horizon.setAttribute('x1', '2');
  horizon.setAttribute('x2', String(w - 2));
  horizon.setAttribute('y1', String(h - 5));
  horizon.setAttribute('y2', String(h - 5));
  horizon.classList.add('skydial-horizon');

  const sun = document.createElementNS(svgNs, 'circle');
  sun.setAttribute('r', '4');
  sun.classList.add('skydial-sun');
  const moon = document.createElementNS(svgNs, 'path');
  moon.setAttribute('d', 'M 0 -4 A 4 4 0 1 0 0 4 A 3 3 0 1 1 0 -4 Z');
  moon.classList.add('skydial-moon');

  svg.append(track, horizon, sun, moon);
  parent.appendChild(svg);

  const along = (p: number): [number, number] => {
    const a = Math.PI * (1 - p);
    return [w / 2 + Math.cos(a) * 28, h - 5 - Math.sin(a) * 28];
  };

  return {
    update(hour) {
      const sky = skyState(hour);
      svg.classList.toggle('night', sky.dayness < 0.5);
      if (sky.sunP !== undefined) {
        const [x, y] = along(sky.sunP);
        sun.setAttribute('cx', x.toFixed(1));
        sun.setAttribute('cy', y.toFixed(1));
        sun.style.display = '';
      } else sun.style.display = 'none';
      if (sky.moonP !== undefined) {
        const [x, y] = along(sky.moonP);
        moon.setAttribute('transform', `translate(${x.toFixed(1)} ${y.toFixed(1)})`);
        moon.style.display = '';
      } else moon.style.display = 'none';
    },
  };
}
